import styled from "styled-components";

export const OffersComponentWrap = styled.div`
  color: #141823;
  border-radius: 0.8rem;
  background-color: #ffffff;
  margin-top: 2rem;
  a {
    color: #2276e3;
  }
  .offersCmp_hdng {
    font-family: 'Rubik';
    font-size: 2.2rem;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    padding: 1rem 2rem;
    border-bottom: 0.1rem solid #eef4fd;
  }

  .offersCmp_cont {
    padding: 0 1rem 1rem;
  }
  .lightGrey {
    color: #898b91;
  }

  .greenText {
    color: #2bac36;
  }

  .offrBox {
    border-radius: 0.8rem;
    border: solid 0.1rem #e5edf6;
    margin-bottom: 1rem;

    > div {
      padding: 1rem 1rem;
      margin-right: 1rem;
    }

    .offrBox__hdng {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem 2rem;
      border-bottom: 0.1rem solid #eef4fd;
    }

    input {
      width: 100%;
      font-family: 'Rubik';
      color: #c2c2c2;
      font-weight: 600;
      padding: 1rem;
      height: 3.8rem;
      border-radius: 0.4rem;
      border: solid 0.1rem #dadada;
    }
  }
  label {
    width: 100%;
  }
`;

export const Strip = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 5rem;
  color: #18a160;
  font-size: 1.2rem;
  border-radius: 0.4rem;
  background-color: #e9f6ea;
  text-align: center;
  margin-top: 1rem;
`;

export const Submit = styled.span`
  width: 3.8rem;
  height: 3.8rem;
  border-radius: 0 0.4rem 0.4rem 0;
  background-color: #dcddde;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 1rem;
  top: 1rem;
`;

export const SelectRadio = styled.div`
  width: 100%;
  padding: 1.6rem 2rem;
  &.active {
    background-color: #fff9f6;
  }
  display: inline-flex;
  flex-direction: column;
  position: relative;

  label {
    position: relative;
    padding-left: 2.8rem;
    line-height: 2rem;
    display: inline-flex;
    cursor: pointer;
  }

  [type="radio"] {
    position: absolute;
    left: -9999px;
  }

  label:after {
    content: "";
    width: 1.2rem;
    height: 1.2rem;
    position: absolute;
    top: 0.4rem;
    left: 0.3rem;
    border-radius: 100%;
    opacity: 0;
    transform: scale(0);
    transition: all 0.2s ease;
    background: #2276e3;
  }

  label:before {
    content: "";
    width: 1.8rem;
    height: 1.8rem;
    position: absolute;
    left: 0;
    top: 0.1rem;
    border-radius: 100%;
    background: #fff;
    border: 0.1rem solid #647a97;
  }

  [type="radio"]:checked + label:before {
    border: 0.1rem solid #2276e3;
  }

  [type="radio"]:checked + label:after {
    opacity: 1;
    transform: scale(1);
  }

  @media (min-width: 768px) {
    /* display: flex; */
  }

  &.disabled {
    background: #eee;
    color: #666;
  }
`;

export const Applied = styled.div`
  display: flex;
  align-items: flex-end;
  width: 11rem;
  height: 3.2rem;
  padding: 9px 8px;
  border-radius: 4px;
  background-color: #e9f6ea;
`;

export const AppliedText = styled.p(
  (props) => ` margin: 0 5px 0 0;
  font-family: ${props.theme.font.fontFamily};
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2bac36;`
);

export const OfferError = styled.p(
  (props) => `
  margin: 0.9rem 0rem 0rem 0rem;
  font-family: ${props.theme.font.fontFamily};
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #ff3a5c;
`
);

export const Gocash = styled.span`
  width: 100%;
  padding: 1.6rem 2rem;
  border-bottom: 0.1rem solid #eef4fd;
  display: inline-flex;
  flex-direction: column;
  position: relative;
`;
